import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import { Button, MaterialIcon } from '../styles/generics'
import Modal from './Modal'

const CheckInExitModal = props => (
  <Modal>
    <Container>
    <MaterialIcon name="help" />
      ¿Querés abandonar la fila?
      <ActionContainer>
        <Button onClick={props.toggleModal}>No</Button>
        <Button onClick={props.confirmCancelCheckIn}>Sí</Button>
      </ActionContainer>
    </Container>
  </Modal>
)

CheckInExitModal.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  confirmCancelCheckIn: PropTypes.func.isRequired
}

export default CheckInExitModal

/*
 * Styles
 */
const Container = styled.div`
  display: flex;
  text-align: center;
  flex-direction: column;
  padding: 20px;
  color: ${props => props.theme.colors.green};
  font-size: 24px;

  @media (min-width: ${props => props.theme.sizes.breakPoints.small}) {
    width: ${props => props.theme.sizes.breakPoints.small};
  }

  > i {
    font-size: 45px;
    margin-bottom: 20px;
  }
`

const ActionContainer = styled.div`
  margin-top: 30px;
  width: 100%;

  > button:first-child {
    margin-bottom: 10px;
  }

  @media (min-width: ${props => props.theme.sizes.breakPoints.small}) {
    display: flex;

    > button {
      :first-child {
        margin: 0 20px 0 0;
      }

      :last-child {
        margin: 0 0 0 20px;
      }
    }
  }
`
